export default "data:image/svg+xml,us.svg"